import { useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay"
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal"
import { useModal } from "../../contexts/ModalContext";
import axios from "axios";

const ModalEditExame = ({ item, onSuccess }) => {

    const { closeModal } = useModal();

    const [ nomeExame, setNomeExame ] = useState( item ? item.exame : '' );
    const [ codigoExame, setCodigoExame ] = useState( item ? item.codigo : '' );

    const handleSubmit = async (e) => {

        console.log( 'teste' );

        e.preventDefault();

        try{

            const formData = new FormData();
            formData.append('nomeExame', nomeExame);
            formData.append('codigoExame', codigoExame);
            if (item) {
                formData.append('id', item.id);
            }

            await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/ASO/SaveExame/', formData, { withCredentials: true });
            
            if( onSuccess ) {
                await onSuccess();
            }

            closeModal();

        }catch (error) {

            console.error( error );

        }

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal size="md" header close={ closeModal } >
                    <Formulario onSubmit={ handleSubmit } >
                        <FormComp
                            title="EXAME"
                            type="text"
                            valor={ nomeExame }
                            changeFunc={( e ) => setNomeExame(e.target.value.toUpperCase())}
                            required
                        />
                        <FormComp
                            title="CÓDIGO"
                            type="text"
                            valor={ codigoExame }
                            changeFunc={( e ) => setCodigoExame(e.target.value.toUpperCase())}
                            required
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalEditExame;